/**
 * 套票組成（`product_components`；admin.products 權限）。
 *
 * 套票商品不建班次——它只定義「含哪些商品」，顧客在機台上為每一段各挑一個時段。
 * 沒有這張表的設定，套票下單會被後端擋下（fail-closed），所以這裡是套票能不能賣的
 * 唯一開關。
 */

import { apiFetch } from './core';

/** 一段組成（回傳帶組成商品的顯示欄位，省得逐一再查商品）。 */
export interface ProductComponent {
  component_product_id: string;
  sort_order: number;
  sku: string;
  name_i18n: Record<string, string>;
  description_i18n: Record<string, string> | null;
  duration_minutes: number | null;
  base_price: string;
  cover_media_id: string | null;
}

export interface ReplaceProductComponentsDto {
  items: Array<{ component_product_id: string; sort_order: number }>;
}

export function listProductComponents(productId: string): Promise<ProductComponent[]> {
  return apiFetch<ProductComponent[]>(`/products/${encodeURIComponent(productId)}/components`, {
    method: 'GET',
  });
}

/** 整組取代（PUT 語意）。已售出的訂單不受影響：分段與金額在下單時就定案了。 */
export function replaceProductComponents(
  productId: string,
  dto: ReplaceProductComponentsDto,
): Promise<ProductComponent[]> {
  return apiFetch<ProductComponent[]>(`/products/${encodeURIComponent(productId)}/components`, {
    method: 'PUT',
    body: dto,
  });
}
